interface IAppConfig {
  baseUrl?: string;
  authUrl?: string;
  signalRUrl?: string;
  webUrl?: string;
  isExtension?: boolean;
}

// Defined only by vite.extension.config.ts's `define` (the side-panel
// build); the hosted app's vite.config.ts never sets it, so the identifier
// itself does not exist in that bundle. `typeof` is the only safe way to
// check that: referencing an undeclared bare global directly throws a
// ReferenceError, unlike a property access on an object (e.g.
// import.meta.env.X), which just returns undefined. See MSPPROC-17664 —
// this used to be import.meta.env.VITE_IS_EXTENSION, which never actually
// worked: Vite resolves import.meta.env into its own static object before
// a user `define` entry gets a chance to match that compound expression
// string, so the property silently evaluated to undefined in every build.
declare const __MSP_IS_EXTENSION__: boolean | undefined;

export const appConfig: IAppConfig = {
  baseUrl: import.meta.env.REACT_APP_BASE_API_URL,
  signalRUrl: import.meta.env.REACT_APP_SIGNAL_R_URL,
  authUrl: import.meta.env.REACT_APP_AUTH_URL,
  webUrl: import.meta.env.REACT_APP_WEB_URL,
  // Google/Microsoft SSO hidden, and getExtensionTheme used instead of
  // getTheme, only when this is true: SSO needs a redirect URI registered
  // for the chrome-extension:// origin, not done yet.
  isExtension: typeof __MSP_IS_EXTENSION__ !== 'undefined' && __MSP_IS_EXTENSION__ === true,
};
